import React from 'react';
import styled from 'styled-components';
import ButtonWithIcon, { Props as PropsButtonWithIcon } from './ButtonWithIcon';

export interface Props extends PropsButtonWithIcon {}

const Arrow = styled.svg`
  ${(p) => p.theme.transition.all};
  width: 1.5em;
  height: 1.5em;
`;

export function ArrowIcon() {
  return (
    <Arrow xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 20">
      <path
        fill="currentColor"
        d="M13.794 9.928a.747.747 0 0 1-.066.313.938.938 0 0 1-.195.273l-5.071 4.961a.714.714 0 0 1-.534.222.74.74 0 0 1-.384-.104.736.736 0 0 1-.28-.274.771.771 0 0 1 .137-.931l4.57-4.46-4.57-4.46a.764.764 0 0 1-.235-.546c0-.143.033-.271.098-.384a.752.752 0 0 1 .28-.267.74.74 0 0 1 .384-.104c.212 0 .39.071.534.215l5.071 4.96a.939.939 0 0 1 .196.274c.043.095.065.2.065.312Z"
      />
    </Arrow>
  );
}

export default React.forwardRef(function ButtonWithArrow(
  { ...props }: Props,
  ref: React.Ref<HTMLButtonElement>
) {
  return <ButtonWithIcon ref={ref} {...props} icon={<ArrowIcon />} />;
});
